import { useContext } from 'react';
import { useStore } from 'zustand';

import { PrettyJSONEditorContext } from './store';
import { JSONEditorState } from './types';

export const useJSONEditorStore = <T,>(
  selector: (state: JSONEditorState) => T
): T => {
  const store = useContext(PrettyJSONEditorContext);
  if (!store) {
    throw new Error(
      'useJSONEditorStore must be used within a JSONEditorContext'
    );
  }
  return useStore(store, selector);
};
